<script>
import { useAlert, useTrack } from 'dashboard/composables';
import BotMetrics from './components/BotMetrics.vue';
import ReportFilterSelector from './components/FilterSelector.vue';
import { GROUP_BY_FILTER } from './constants';
import { REPORTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import ReportHeader from './components/ReportHeader.vue';

const BOT_GROUP_BY_OPTIONS = [
  { id: 'none', name: 'BOT_REPORTS.GROUP_BY.NONE' },
  { id: 'inboxes', name: 'BOT_REPORTS.GROUP_BY.INBOXES' },
  { id: 'labels', name: 'BOT_REPORTS.GROUP_BY.LABELS' },
];

export default {
  name: 'BotReports',
  components: {
    BotMetrics,
    ReportHeader,
    ReportFilterSelector,
  },
  data() {
    return {
      from: 0,
      to: 0,
      groupBy: GROUP_BY_FILTER[1],
      businessHours: false,
      botGroupBy: BOT_GROUP_BY_OPTIONS[0],
      botGroupByOptions: BOT_GROUP_BY_OPTIONS,
    };
  },
  computed: {
    requestPayload() {
      return {
        from: this.from,
        to: this.to,
        groupBy: this.botGroupBy.id === 'none' ? undefined : this.botGroupBy.id,
      };
    },
    translatedGroupByOptions() {
      return this.botGroupByOptions.map(opt => ({
        ...opt,
        translatedName: this.$t(opt.name),
      }));
    },
    selectedBotGroupBy() {
      return this.translatedGroupByOptions.find(
        opt => opt.id === this.botGroupBy.id
      );
    },
  },
  methods: {
    fetchAllData() {
      this.fetchBotSummary();
    },
    fetchBotSummary() {
      try {
        this.$store.dispatch('fetchBotSummary', this.getRequestPayload());
      } catch {
        useAlert(this.$t('REPORT.SUMMARY_FETCHING_FAILED'));
      }
    },
    getRequestPayload() {
      const { from, to, groupBy, businessHours } = this;

      return {
        from,
        to,
        groupBy: groupBy?.period,
        businessHours,
      };
    },
    onFilterChange({ from, to, groupBy, businessHours }) {
      this.from = from;
      this.to = to;
      this.groupBy = groupBy;
      this.businessHours = businessHours;
      this.fetchAllData();

      useTrack(REPORTS_EVENTS.FILTER_REPORT, {
        filterValue: { from, to, groupBy, businessHours },
        reportType: 'bots',
      });
    },
    onBotGroupByChange(option) {
      this.botGroupBy = option;
    },
  },
};
</script>

<template>
  <ReportHeader :header-title="$t('BOT_REPORTS.HEADER')" />
  <div class="flex flex-col gap-4">
    <div class="flex items-start gap-1.5">
      <ReportFilterSelector
        :show-agents-filter="false"
        :show-group-by-filter="false"
        :show-business-hours-switch="false"
        @filter-change="onFilterChange"
      />
      <div class="multiselect-wrap--small min-w-[200px]">
        <multiselect
          :model-value="selectedBotGroupBy"
          class="no-margin"
          track-by="id"
          label="translatedName"
          :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
          selected-label
          :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
          deselect-label=""
          :options="translatedGroupByOptions"
          :searchable="false"
          :allow-empty="false"
          @select="onBotGroupByChange"
        />
      </div>
    </div>

    <BotMetrics :filters="requestPayload" />
  </div>
</template>
